import React from 'react'
import { connect } from 'react-redux'
import { updateInput, queueSong, nextSong } from './actions'

const App = ({ queue, input, currentSong, onChangeInput, onSubmit, skipSong }) => (
    <main className="flex flex-column sans-serif items-center justify-center bg-near-white black-70">
        {currentSong ? <marquee className="absolute top-0 left-0 w-100 bb b--black-20 pv1 f6 fw1 bg-washed-blue">Now Playing: <a className="link dim black-70" href={currentSong}>{currentSong}</a></marquee> : null}

        <h1 className="f3 fw6 mt0 mb3 flex items-center">
            IRC Radio
            <span className="f2 fw9 mh2">@</span>
            #kellyirc
        </h1>
        
        <div className="mb3 tc">
            <div>
                <audio className="ba br1 b--black-20" controls src="http://rahat.bot.nu:8000/stream.ogg" type="audio/ogg">
            </audio>
        </div>
        <a className="link dim black-30" href="http://rahat.bot.nu:8000/stream.ogg"><small>Stream Direct Link</small></a>
    </div>

    <div className="flex mb4">
        <div>
            <form onSubmit={(e) => onSubmit(e, input)}>
                <input type="text" className="f5 ph2 pv1 ba br1 black-70 b--black-20 mr1" placeholder="Add URL to queue..." value={input} onChange={onChangeInput}/>
                <button type="submit" className="f5 link pointer hover-bg-black-10 bg-animate ph2 pv1 dib ba br1 black-70 b--black-20 bg-near-white">Add</button>
            </form>
        </div>
        <div className="br b--black-10 mh2"></div>
        <button className="f5 link pointer hover-bg-black-10 bg-animate ph2 pv1 dib ba br1 black-70 b--black-20 bg-near-white" type="button" onClick={skipSong}>Skip this song</button>
    </div>

    {queue.length === 0 ? null : <div>
        <h1 className="f5 fw5 mt0 mb2 mr4 dib lh-copy ">Up Next</h1>
        <ul className="list mv0 fr pl0">
            {queue.map((song, i) => (
                <li key={song} className="lh-copy"><a className="f5 fw1 link dim black-70" href={song} key={i}>{song}</a></li>
            ))}
        </ul>
    </div>}

</main>
)

const mapStateToProps = ({ queue, currentSong, input }) => ({ queue, currentSong, input })
const mapDispatchToProps = dispatch => {
    return {
        onChangeInput: (e) => dispatch(updateInput(e.target.value)),
        onSubmit: (e, song) => {
            e.preventDefault()
            dispatch(queueSong(song))
        },
        skipSong: () => dispatch(nextSong())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/